export enum FormOfTeachingSort {
  Name = 1
}